(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dvk-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(el){
    var track=el.querySelector('[data-dvk-ann-track]'); if(!track) return;
    var speed=parseFloat(el.getAttribute('data-speed'))||40;
    function calc(){ var half=track.scrollWidth/2; if(half>0) el.style.setProperty('--dvk-ann-dur',(half/speed).toFixed(2)+'s'); }
    calc();
    if(window.ResizeObserver){ new ResizeObserver(calc).observe(track); } else { window.addEventListener('resize',calc); }
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(calc);
  }
  function init(){ document.querySelectorAll('[data-dvk-ann]').forEach(function(el){ if(!el.__dvk){ el.__dvk=true; setup(el); } }); }
  init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvk-faq-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__dvk) return; root.__dvk=true;
    var input=root.querySelector('[data-dvk-faqsearch]'), none=root.querySelector('[data-dvk-faqnone]');
    var items=[].slice.call(root.querySelectorAll('[data-dvk-faqitem]')), groups=[].slice.call(root.querySelectorAll('[data-dvk-faqgroup]'));
    if(!input) return;
    var t;
    input.addEventListener('input',function(){
      clearTimeout(t);
      t=setTimeout(function(){
        var q=input.value.trim().toLowerCase(), shown=0;
        items.forEach(function(it){
          var hit=!q||it.textContent.toLowerCase().indexOf(q)>-1;
          it.hidden=!hit; if(hit) shown++;
          if(q&&hit) it.open=true; if(!q) it.open=false;
        });
        groups.forEach(function(g){ g.hidden=!g.querySelector('[data-dvk-faqitem]:not([hidden])'); });
        if(none) none.hidden=shown>0;
      },120);
    });
  }
  function boot(){ document.querySelectorAll('[data-dvk-faqp]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-dvk-faqp]'); if(r){ r.__dvk=false; init(r); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvk-header"]) return;
  try {
    
(function(){
  function init(){
    var menu=document.querySelector('[data-dvk-menu]'); if(!menu||menu.__dvk) return; menu.__dvk=true;
    var lastFocus=null;
    function open(){ lastFocus=document.activeElement; menu.hidden=false; document.documentElement.style.overflow='hidden'; var x=menu.querySelector('.dvk-menu__x'); if(x) x.focus(); }
    function close(){ menu.hidden=true; document.documentElement.style.overflow=''; if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
    document.querySelectorAll('[data-dvk-menu-open]').forEach(function(b){ b.addEventListener('click',open); });
    menu.querySelectorAll('[data-dvk-menu-close]').forEach(function(b){ b.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!menu.hidden) close(); });
    menu.querySelectorAll('[data-dvk-macc]').forEach(function(b){
      b.addEventListener('click',function(){
        var sub=document.getElementById(b.getAttribute('aria-controls')), isOpen=b.getAttribute('aria-expanded')==='true';
        menu.querySelectorAll('[data-dvk-macc][aria-expanded="true"]').forEach(function(o){ if(o!==b){ o.setAttribute('aria-expanded','false'); var s=document.getElementById(o.getAttribute('aria-controls')); if(s) s.hidden=true; var g=o.querySelector('.dvk-menu__sign'); if(g) g.textContent='+'; } });
        b.setAttribute('aria-expanded',isOpen?'false':'true'); if(sub) sub.hidden=isOpen;
        var sign=b.querySelector('.dvk-menu__sign'); if(sign) sign.textContent=isOpen?'+':'−';
      });
    });
    var tabs=[].slice.call(menu.querySelectorAll('[data-dvk-mtab]'));
    tabs.forEach(function(t){ t.addEventListener('click',function(){
      tabs.forEach(function(x){ x.setAttribute('aria-selected',x===t?'true':'false'); x.tabIndex=(x===t)?0:-1; var p=document.getElementById(x.getAttribute('aria-controls')); if(p) p.hidden=(x!==t); });
    }); });
  }
  init();
  document.addEventListener('shopify:section:load',init);
})();
(function(){
  function initMega(){
    var nav=document.querySelector('[data-dvk-mega]'); if(!nav||nav.__dvk) return; nav.__dvk=true;
    var items=[].slice.call(nav.querySelectorAll('[data-dvk-mega-item].has-panel'));
    var openT=null, closeT=null, current=null;
    function setOpen(it,on){ if(!it) return; it.classList.toggle('is-open',on); var a=it.querySelector('.dvk-mega__link'); if(a) a.setAttribute('aria-expanded',on?'true':'false'); }
    function open(it){ clearTimeout(closeT); if(current&&current!==it) setOpen(current,false); current=it; setOpen(it,true); }
    function closeAll(){ items.forEach(function(i){ setOpen(i,false); }); current=null; }
    items.forEach(function(it){
      it.addEventListener('mouseenter',function(){ clearTimeout(closeT); clearTimeout(openT); openT=setTimeout(function(){ open(it); }, current?0:120); });
      it.addEventListener('mouseleave',function(){ clearTimeout(openT); closeT=setTimeout(function(){ if(current===it){ setOpen(it,false); current=null; } },180); });
      it.addEventListener('focusin',function(){ open(it); });
      var a=it.querySelector('[data-dvk-mega-noop]');
      if(a) a.addEventListener('click',function(e){ e.preventDefault(); if(it.classList.contains('is-open')) closeAll(); else open(it); });
    });
    nav.addEventListener('focusout',function(e){ if(!nav.contains(e.relatedTarget)) closeAll(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&current){ var a=current.querySelector('.dvk-mega__link'); closeAll(); if(a) a.focus(); } });
    document.addEventListener('click',function(e){ if(current&&!nav.contains(e.target)) closeAll(); });
  }
  initMega();
  document.addEventListener('shopify:section:load',initMega);
})();
(function(){
  function initSticky(){
    var h=document.querySelector('[data-dvk-hdr]'); if(!h) return;
    var sec=h.closest('.shopify-section'); if(!sec) return;
    var spacer=sec.previousElementSibling;
    if(!spacer||!spacer.classList||!spacer.classList.contains('dvk-hdr-spacer')){
      spacer=document.createElement('div'); spacer.className='dvk-hdr-spacer'; spacer.setAttribute('aria-hidden','true');
      sec.parentNode.insertBefore(spacer,sec);
    }
    if(sec.__dvkOff) sec.__dvkOff();
    function reset(){ sec.classList.remove('is-fixed','is-hidden','no-anim'); spacer.classList.remove('is-on'); spacer.style.height=''; }
    if(!h.hasAttribute('data-sticky')){ reset(); return; }
    var lastY=window.pageYOffset, ticking=false, fixed=false;
    function startY(){ return spacer.classList.contains('is-on') ? spacer.getBoundingClientRect().top+window.pageYOffset : sec.getBoundingClientRect().top+window.pageYOffset; }
    var top=startY();
    function menuOpen(){ return !!h.querySelector('.dvk-mega__item.is-open'); }
    function setFixed(on){
      if(on===fixed) return; fixed=on;
      if(on){ spacer.style.height=sec.offsetHeight+'px'; spacer.classList.add('is-on'); sec.classList.add('is-fixed'); }
      else { sec.classList.remove('is-fixed','is-hidden'); spacer.classList.remove('is-on'); spacer.style.height=''; }
    }
    function noAnim(fn){ sec.classList.add('no-anim'); fn(); void sec.offsetHeight; requestAnimationFrame(function(){ sec.classList.remove('no-anim'); }); }
    function upd(){
      ticking=false;
      var y=window.pageYOffset, hgt=sec.offsetHeight, down=y>lastY, delta=Math.abs(y-lastY);
      if(y<=top){ setFixed(false); }
      else if(!fixed){
        if(y>top+hgt){ noAnim(function(){ setFixed(true); sec.classList.add('is-hidden'); }); }
      } else if(delta>4){
        if(down && y>top+hgt && !menuOpen()) sec.classList.add('is-hidden');
        else if(!down) sec.classList.remove('is-hidden');
      }
      lastY=y;
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(upd); } }
    function onResize(){ if(!fixed) top=startY(); else spacer.style.height=sec.offsetHeight+'px'; }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onResize);
    sec.addEventListener('focusin',function(){ sec.classList.remove('is-hidden'); });
    sec.__dvkOff=function(){ window.removeEventListener('scroll',onScroll); window.removeEventListener('resize',onResize); reset(); };
    upd();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSticky); else initSticky();
  window.addEventListener('load',function(){ var h=document.querySelector('[data-dvk-hdr]'); if(h) { window.dispatchEvent(new Event('resize')); } });
  document.addEventListener('shopify:section:load',initSticky);
})();
(function(){
  function initSearch(){
    var ov=document.querySelector('[data-dvk-search]'); if(!ov) return;
    if(ov.__dvk) return; ov.__dvk=true;
    var input=ov.querySelector('[data-dvk-search-input]'), clearB=ov.querySelector('[data-dvk-search-clear]'),
        form=ov.querySelector('[data-dvk-search-form]'), body=ov.querySelector('[data-dvk-search-body]'),
        sugg=ov.querySelector('[data-dvk-sugg]'), grid=ov.querySelector('[data-dvk-grid]'), all=ov.querySelector('[data-dvk-all]'),
        live=ov.querySelector('[data-dvk-live]'), emptyQ=ov.querySelector('[data-dvk-empty-q]'),
        recentWrap=ov.querySelector('[data-dvk-recent-wrap]'), recentBox=ov.querySelector('[data-dvk-recent]');
    var views={}; [].forEach.call(ov.querySelectorAll('[data-view]'),function(v){ views[v.getAttribute('data-view')]=v; });
    var SUGGEST=ov.getAttribute('data-suggest-url')||'/search/suggest', SEARCH=ov.getAttribute('data-search-url')||'/search';
    var KEY='dvk_recent_searches', cache={}, ctrl=null, timer=null, isOpen=false, pushed=false, lastFocus=null, seq=0;
    function esc(t){ return String(t==null?'':t).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function money(v){ var n=parseFloat(v); if(!isFinite(n)||n<=0) return ''; return '₹'+Math.round(n).toLocaleString('en-IN'); }
    function img(u,w){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u+(u.indexOf('?')>-1?'&':'?')+'width='+w; }
    function searchHref(q){ return SEARCH+'?q='+encodeURIComponent(q)+'&options%5Bprefix%5D=last'; }
    function getRecent(){ try{ var r=JSON.parse(localStorage.getItem(KEY)||'[]'); return Array.isArray(r)?r:[]; }catch(e){ return []; } }
    function saveRecent(q){ q=(q||'').trim(); if(q.length<2) return; var r=getRecent().filter(function(x){ return String(x).toLowerCase()!==q.toLowerCase(); }); r.unshift(q); try{ localStorage.setItem(KEY,JSON.stringify(r.slice(0,6))); }catch(e){} }
    var clock='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#8A7671" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';
    var lens='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#8A7671" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
    function renderRecent(){
      if(!recentWrap) return; var r=getRecent();
      if(!r.length){ recentWrap.hidden=true; recentBox.innerHTML=''; return; }
      recentBox.innerHTML=r.map(function(q){ return '<button type="button" class="dvk-srch__rrow" data-dvk-q="'+esc(q)+'">'+clock+'<span>'+esc(q)+'</span></button>'; }).join('');
      recentWrap.hidden=false;
    }
    function show(name){ for(var k in views){ views[k].hidden=(k!==name); } }
    var RVKEY='dvk_recently_viewed', rvWrap=ov.querySelector('[data-dvk-rv-wrap]'), rvBox=ov.querySelector('[data-dvk-rv]');
    function getRV(){ try{ var r=JSON.parse(localStorage.getItem(RVKEY)||'[]'); return Array.isArray(r)?r:[]; }catch(e){ return []; } }
    (function recordRV(){
      var tag=document.querySelector('[data-dvk-rv-current]'); if(!tag) return;
      try{ var cur=JSON.parse(tag.textContent); if(!cur||!cur.h) return;
        var list=getRV().filter(function(x){ return x&&x.h!==cur.h; }); list.unshift(cur);
        localStorage.setItem(RVKEY,JSON.stringify(list.slice(0,10))); }catch(e){}
    })();
    function renderRV(){
      if(!rvWrap) return;
      var here=document.querySelector('[data-dvk-rv-current]'), curH=null;
      if(here){ try{ curH=JSON.parse(here.textContent).h; }catch(e){} }
      var list=getRV().filter(function(x){ return x&&x.u&&x.h!==curH; }).slice(0,8);
      if(!list.length){ rvWrap.hidden=true; rvBox.innerHTML=''; return; }
      rvBox.innerHTML=list.map(function(x){
        var im=x.i?(x.i.indexOf('//')===0?'https:'+x.i:x.i):'';
        return '<a class="dvk-srch__rvc" href="'+esc(x.u)+'"><span class="dvk-srch__cimg">'+(im?'<img src="'+esc(im)+'" alt="'+esc(x.t)+'" loading="lazy" decoding="async" width="240" height="320" onload="this.classList.add(\'is-loaded\')">':'')+'</span><span class="dvk-srch__cname">'+esc(x.t)+'</span><span class="dvk-srch__price">'+esc(x.p||'')+(x.c?'<s>'+esc(x.c)+'</s>':'')+'</span></a>';
      }).join('');
      rvWrap.hidden=false;
    }
    function bold(text,q){
      var t=String(text||''), i=t.toLowerCase().indexOf(q.toLowerCase());
      if(i<0) return esc(t);
      return esc(t.slice(0,i))+'<strong>'+esc(t.slice(i,i+q.length))+'</strong>'+esc(t.slice(i+q.length));
    }
    function skeleton(){
      var c=''; for(var i=0;i<4;i++){ c+='<div class="dvk-srch__card" aria-hidden="true"><span class="dvk-srch__skel dvk-srch__skel--img"></span><span class="dvk-srch__skel dvk-srch__skel--line"></span><span class="dvk-srch__skel dvk-srch__skel--line short"></span></div>'; }
      grid.innerHTML=c;
    }
    function card(p){
      var im=p.image||(p.featured_image&&p.featured_image.url)||'';
      var cmp=parseFloat(p.compare_at_price_max||p.compare_at_price||0), pr=parseFloat(p.price||p.price_min||0);
      var price='<span class="dvk-srch__price">'+money(p.price||p.price_min)+(cmp>pr&&pr>0?'<s>'+money(cmp)+'</s><em>'+Math.floor((1-pr/cmp)*100)+'% off</em>':'')+'</span>';
      return '<a class="dvk-srch__card" href="'+esc(p.url)+'" data-dvk-pick><span class="dvk-srch__cimg">'+(im?'<img src="'+esc(img(im,360))+'" srcset="'+esc(img(im,240))+' 240w, '+esc(img(im,360))+' 360w, '+esc(img(im,480))+' 480w" sizes="46vw" alt="'+esc(p.title)+'" loading="lazy" decoding="async" width="360" height="480" onload="this.classList.add(\'is-loaded\')">':'')+'</span><span class="dvk-srch__cname">'+esc(p.title)+'</span>'+price+'</a>';
    }
    function render(q,res){
      var products=(res.products||[]), cols=(res.collections||[]), queries=(res.queries||[]);
      if(!products.length && !cols.length){
        emptyQ.textContent=q; show('empty'); live.textContent='No results for '+q; return;
      }
      show('typing');
      var rows=['<a class="dvk-srch__srow" href="'+esc(searchHref(q))+'" data-dvk-pick>'+lens+'<span><strong>'+esc(q)+'</strong></span><small>Search all</small></a>'];
      cols.slice(0,2).forEach(function(c){ rows.push('<a class="dvk-srch__srow" href="'+esc(c.url)+'" data-dvk-pick>'+lens+'<span>'+bold(c.title,q)+'</span><small>Category</small></a>'); });
      var seen={}; seen[q.toLowerCase()]=1;
      queries.forEach(function(x){ var t=(x.text||'').trim(); if(!t||seen[t.toLowerCase()]||rows.length>=6) return; seen[t.toLowerCase()]=1; rows.push('<a class="dvk-srch__srow" href="'+esc(searchHref(t))+'" data-dvk-pick data-dvk-save="'+esc(t)+'">'+lens+'<span>'+bold(t,q)+'</span><small></small></a>'); });
      sugg.innerHTML=rows.join('');
      var prodBlock=grid.parentNode;
      if(products.length){ prodBlock.hidden=false; grid.innerHTML=products.slice(0,4).map(card).join(''); }
      else { prodBlock.hidden=true; grid.innerHTML=''; }
      all.href=searchHref(q);
      live.textContent=products.length+' products found';
    }
    function fetchSuggest(q){
      var key=q.toLowerCase();
      if(cache[key]){ render(q,cache[key]); return; }
      if(ctrl){ try{ ctrl.abort(); }catch(e){} }
      ctrl=window.AbortController?new AbortController():null;
      var my=++seq;
      show('typing'); grid.parentNode.hidden=false;
      if(!grid.querySelector('.dvk-srch__card:not([aria-hidden])')) skeleton();
      sugg.innerHTML='<a class="dvk-srch__srow" href="'+esc(searchHref(q))+'" data-dvk-pick>'+lens+'<span><strong>'+esc(q)+'</strong></span><small>Search all</small></a>';
      all.href=searchHref(q);
      var base=SUGGEST.split('?')[0].replace(/\/$/,'').replace(/\.json$/,'')+'.json';
      var u=base+'?q='+encodeURIComponent(q)+'&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(u,{signal:ctrl?ctrl.signal:undefined,headers:{Accept:'application/json'},credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
        .then(function(d){ var res=(d&&d.resources&&d.resources.results)||{}; cache[key]=res; if(my===seq && input.value.trim().toLowerCase()===key) render(q,res); })
        .catch(function(e){ if(e&&e.name==='AbortError') return; if(my===seq){ grid.parentNode.hidden=true; grid.innerHTML=''; live.textContent='Press search to see results'; } });
    }
    function run(){
      var q=input.value.trim(); clearB.hidden=!input.value.length;
      if(q.length<2){ if(ctrl){ try{ ctrl.abort(); }catch(e){} } seq++; renderRecent(); renderRV(); show('default'); return; }
      fetchSuggest(q);
    }
    function lock(on){ document.documentElement.style.overflow=on?'hidden':''; document.body.style.overflow=on?'hidden':''; }
    function open(prefill){
      if(isOpen){ input.focus(); return; }
      lastFocus=document.activeElement; isOpen=true; ov.hidden=false; lock(true); renderRecent();
      if(typeof prefill==='string'){ input.value=prefill; }
      run(); input.focus({preventScroll:true});
      try{ history.pushState({dvkSearch:1},''); pushed=true; }catch(e){ pushed=false; }
    }
    function hide(){ if(!isOpen) return; isOpen=false; ov.hidden=true; lock(false); if(ctrl){ try{ ctrl.abort(); }catch(e){} } if(lastFocus&&lastFocus.blur) lastFocus.blur(); }
    var ignorePop=false;
    function close(){ var p=pushed; pushed=false; hide(); if(p){ ignorePop=true; try{ history.back(); }catch(e){ ignorePop=false; } } }
    window.addEventListener('popstate',function(){ if(ignorePop){ ignorePop=false; return; } if(isOpen){ pushed=false; hide(); } });
    function go(q){ q=(q||'').trim(); if(!q) return; saveRecent(q); window.location.href=searchHref(q); }

    input.addEventListener('input',function(){ clearB.hidden=!input.value.length; clearTimeout(timer); timer=setTimeout(run,170); });
    form.addEventListener('submit',function(e){ e.preventDefault(); go(input.value); });
    clearB.addEventListener('click',function(){ input.value=''; run(); input.focus(); });
    [].forEach.call(ov.querySelectorAll('[data-dvk-search-close]'),function(b){ b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); close(); }); });
    ov.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    ov.addEventListener('click',function(e){
      var qb=e.target.closest('[data-dvk-q]');
      if(qb){ e.preventDefault(); input.value=qb.getAttribute('data-dvk-q'); clearTimeout(timer); run(); return; }
      var rc=e.target.closest('[data-dvk-recent-clear]');
      if(rc){ try{ localStorage.removeItem(KEY); }catch(err){} renderRecent(); return; }
      if(e.target.closest('[data-dvk-rv-clear]')){ try{ localStorage.removeItem(RVKEY); }catch(err){} renderRV(); return; }
      var sv=e.target.closest('[data-dvk-save]');
      if(sv){ saveRecent(sv.getAttribute('data-dvk-save')); }
      else if(e.target.closest('[data-dvk-pick]')){ saveRecent(input.value); }
    });
    body.addEventListener('touchstart',function(){ if(document.activeElement===input) input.blur(); },{passive:true});

    document.addEventListener('click',function(e){
      var t=e.target.closest('[data-dvk-search-open]'); if(!t) return;
      e.preventDefault(); var src=t.querySelector('input[type=search]'); open(src&&src.value?src.value:undefined);
    });
    document.addEventListener('focusin',function(e){
      var t=e.target.closest&&e.target.closest('[data-dvk-search-open]'); if(!t||isOpen) return;
      open(e.target.value||undefined);
    });
    document.addEventListener('submit',function(e){
      var t=e.target.closest&&e.target.closest('[data-dvk-search-open]'); if(!t) return;
      e.preventDefault(); open();
    });
  }
  function initPh(){
    var ov=document.querySelector('[data-dvk-search]'); if(!ov||window.__dvkPh) return; window.__dvkPh=true;
    var words=(ov.getAttribute('data-ph-words')||'').split(/[|,]/).map(function(w){ return w.trim(); }).filter(Boolean);
    if(!words.length) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i=0, txt='', del=false;
    function set(v){ [].forEach.call(document.querySelectorAll('[data-dvk-ph-word]'),function(el){ el.textContent=v; }); }
    if(reduce){ set(words[0]); setInterval(function(){ i=(i+1)%words.length; set(words[i]); },2600); return; }
    function tick(){
      var w=words[i];
      if(!del){ txt=w.slice(0,txt.length+1); set(txt); if(txt===w){ del=true; return setTimeout(tick,1700); } return setTimeout(tick,70); }
      txt=w.slice(0,txt.length-1); set(txt); if(!txt){ del=false; i=(i+1)%words.length; return setTimeout(tick,250); } setTimeout(tick,35);
    }
    set(''); setTimeout(tick,400);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ initSearch(); initPh(); }); else { initSearch(); initPh(); }
  document.addEventListener('shopify:section:load',function(){ var ov=document.querySelector('[data-dvk-search]'); if(ov) ov.__dvk=false; initSearch(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvk-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var track=root.querySelector('[data-dvk-hero]'); if(!track||track.__dvk) return; track.__dvk=true;
    var slides=[].slice.call(track.children), dots=[].slice.call(root.querySelectorAll('[data-dvk-dot]'));
    var i=0, timer=null, interval=(parseInt(track.dataset.interval,10)||5)*1000;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n){ i=(n+slides.length)%slides.length; track.scrollTo({left:slides[i].offsetLeft-track.offsetLeft,behavior:reduce?'auto':'smooth'}); sync(); }
    function sync(){ dots.forEach(function(d,k){ d.setAttribute('aria-current',k===i?'true':'false'); }); slides.forEach(function(s,k){ var v=s.querySelector('video'); if(v&&k!==i){ v.pause(); } }); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function start(){ if(reduce||slides.length<2) return; stop(); timer=setInterval(function(){ if(document.hidden) return; var v=slides[i].querySelector('video'); if(v&&!v.paused) return; go(i+1); },interval); }
    dots.forEach(function(d){ d.addEventListener('click',function(){ stop(); go(parseInt(d.dataset.dvkDot,10)); }); });
    var p=root.querySelector('[data-dvk-prev]'), n=root.querySelector('[data-dvk-next]');
    if(p) p.addEventListener('click',function(){ stop(); go(i-1); });
    if(n) n.addEventListener('click',function(){ stop(); go(i+1); });
    track.addEventListener('touchstart',stop,{passive:true});
    track.addEventListener('scroll',function(){ var k=Math.round(track.scrollLeft/track.clientWidth); if(k!==i&&k>=0&&k<slides.length){ i=k; sync(); } },{passive:true});
    root.querySelectorAll('[data-dvk-play]').forEach(function(b){ b.addEventListener('click',function(){ var v=b.parentNode.querySelector('video'); if(!v) return; stop(); if(v.paused){ v.play(); b.setAttribute('aria-label','Pause video'); b.style.opacity='0'; } else { v.pause(); b.setAttribute('aria-label','Play video'); b.style.opacity='1'; } }); });
    start();
  }
  document.querySelectorAll('.dvk-hero').forEach(init);
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('.dvk-hero'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvk-product-recs"] && !Shopify.designMode) return;
  try {
    
(function(){
  function esc(t){ return String(t==null?'':t).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function init(root){
    if(!root||root.__dvk) return; root.__dvk=true;
    var rvRow=root.querySelector('[data-dvk-rvrow]'), rvGrid=root.querySelector('[data-dvk-rvgrid]');
    if(rvRow&&rvGrid){
      var list=[]; try{ list=JSON.parse(localStorage.getItem('dvk_recently_viewed')||'[]'); }catch(e){}
      var me=root.getAttribute('data-handle');
      list=(Array.isArray(list)?list:[]).filter(function(x){ return x&&x.u&&x.h!==me; }).slice(0,6);
      if(list.length){
        rvGrid.innerHTML=list.map(function(x){
          var im=x.i?(x.i.indexOf('//')===0?'https:'+x.i:x.i):'';
          return '<a class="dvk-recs__card" href="'+esc(x.u)+'"><span class="dvk-recs__img" style="background:#E3CEC4">'+(im?'<img src="'+esc(im)+'" alt="" loading="lazy" decoding="async" width="240" height="320">':'')+'</span><span class="dvk-recs__t">'+esc(x.t)+'</span><span class="dvk-recs__pr"><span class="dvk-recs__p">'+esc(String(x.p||'').replace(/\s+/g,''))+'</span></span></a>';
        }).join('');
        rvRow.hidden=false;
      }
    }
  }
  function boot(){ document.querySelectorAll('[data-dvk-recs]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-dvk-recs]'); if(r){ r.__dvk=false; init(r); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvk-shop-by"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__dvk) return; root.__dvk=true;
    var tabs=[].slice.call(root.querySelectorAll('[data-dvk-tab]'));
    tabs.forEach(function(t){ t.addEventListener('click',function(){
      tabs.forEach(function(x){ x.setAttribute('aria-selected',x===t?'true':'false'); var p=document.getElementById(x.getAttribute('aria-controls')); if(p) p.hidden=(x!==t); });
    }); });
  }
  document.querySelectorAll('[data-dvk-tabs]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){ e.target.querySelectorAll('[data-dvk-tabs]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();
})();
